import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'keyvalue',
})
export class KeyValuePipe implements PipeTransform {
  transform(value: { [key: string]: any }): { key: string; value: any }[] {
    if (!value || typeof value !== 'object') {
      return [];
    }
    return Object.keys(value).map((key) => ({ key, value: value[key] }));
  }
}
